module.exports = __webpack_public_path__ + "static/media/link-account.db29ac03.svg";